<template>
    <div class="bg-white border border-dark-subtle overflow-hidden" >
        <div class="d-flex flex-column bd-highlight mb-0" style="border:0px dashed red;">
            <div class="row">
                <div class="col-lg-4">
                    <div class="flex items-center py-1 px-2 text-secondary-emphasis">
                        <div class=""><span class="font-weight-bold text-muted text-md ">Invoice</span></div>
                        <span v-if="_getAddress.name == ''">
                            <button type="button" class="btn btn-outline-secondary" v-on:click="editShippingAddress" >Ajouter un client <i class='fas fa-user-plus mx-2'></i></button>
                        </span>
                        <span v-else>
                            <a class="cursorPoint text-secondary" v-on:click="editShippingAddress" ><i class='fas fa-user-edit'></i></a>
                            <a class="ml-1 cursorPoint text-secondary" v-on:click="removeClient" ><i class='fas fa-user-minus'></i></a>
                            <br/>
                            <strong v-if="_getAddress.number != ''"># </strong><strong v-text="_getAddress.number"></strong>
                            <address class="text-secondary text-sm">
                                <strong v-text="_getAddress.name"></strong><br>
                                <span v-text="_getAddress.address1"></span>,<br>
                                <span v-text="_getAddress.city"></span>, <span v-text="_getAddress.zipcode"></span><br>
                                P: <span v-text="_getAddress.tel1"></span>
                            </address>
                        </span>
                        
                        
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="flex items-center py-1 px-2 text-secondary-emphasis">
                        <div class=""><span class="font-weight-bold text-muted text-md ">Facturé à</span></div>
                        <span v-if="_getBillAddress.name == ''">
                            <span v-if="_getAddress.name != ''">
                                <a class="cursorPoint text-secondary" v-on:click="copyShippingAddress" ><i class='fas fa-user-friends'></i></a> 
                                <a class="ml-1 cursorPoint text-secondary" v-on:click="editBillAddress" ><i class='fas fa-user-plus'></i></a>
                            </span>
                            <span v-else>
                                <button type="button" class="btn btn-outline-secondary" v-on:click="editBillAddress" >Ajouter une addresse <i class='fas fa-user-plus mx-2'></i></button>
                            </span>
                        </span>
                        <span v-else>
                            <a class="cursorPoint text-secondary" v-on:click="editBillAddress" ><i class='fas fa-user-edit'></i></a>
                            <a v-if="_getAddress.name != ''" class="ml-1 cursorPoint text-secondary" v-on:click="copyShippingAddress" ><i class='fas fa-user-friends'></i></a>
                            <a class="ml-1 cursorPoint text-secondary" v-on:click="removeBillingAddress" ><i class='fas fa-user-minus'></i></a>
                            <br>
                            <strong v-if="_getBillAddress.number != ''"># </strong><strong v-text="_getBillAddress.number"></strong>
                            <span v-if="_getBillAddress.name != ''">
                                <address class="text-secondary text-sm">
                                    <strong v-text="_getBillAddress.name"></strong><br>
                                    <span v-text="_getBillAddress.address1"></span>,<br>
                                    <span v-text="_getBillAddress.city"></span>, <span v-text="_getBillAddress.zipcode"></span><br>
                                    P: <span v-text="_getBillAddress.tel1"></span><br>
                                </address>
                            </span>
                        </span>
                        
                    </div>
                    


                </div>

                <div class="col-lg-4">
                    <div class="flex items-center p-2 text-secondary-emphasis">
                        <div class=""><span class="font-weight-bold text-muted text-md ">Note</span></div>
                        <textarea rows="4" class="form-control d-inline-flex focus-ring focus-ring-light text-decoration-none border border-2 rounded-2" placeholder="Note de magasin (Interne)" id="floatingTextarea"></textarea>
                    </div>
                </div>
            </div>
            <!-- <div class="p-2" style="border:1px dashed blue;">Flex item 1</div> -->
        </div>


        <!-- Card header -->
        <div class="d-flex justify-content-between m-2 d-flex align-items-stretch">
            <div class="container text-center">
                <div class="row row-cols-4">
                    <div class="col">

                    </div>
                </div>
            </div>
            
        </div>

        

        
    </div>
</template>

<script>

import mapGetter from '@/mixins/getters.js'
import store from '@/store'


export default{
    name: "invoiceHeader",
    mixins:[mapGetter],
    components: {

    },
    props: {
        clientAddress: {
            type: Object,
            required: false,
            default() {
                return  {
                    id : 0,
                    number : "",
                    name: "",
                    address1: "",
                    city: "",
                    zipcode: "",
                    tel1: "",
                }
            }
        },
        billingAddress: {
            type: Object,
            required: false,
            default() {
                return  {
                    id : 0,
                    number : "",
                    name: "",
                    address1: "",
                    city: "",
                    zipcode: "",
                    tel1: "",
                }
            }
        },
    },
    data() {
        return{
            txtRecherche : '',

        }
    },
    methods: {
        isValid : (str) => (!(str === "undefined" || str?.length == 0)), //Valide si le champs n'est pas indefini ni vide
        editBillAddress() {
            this.$emit('openBilling') 
        },
        copyShippingAddress() {
            this._getBillAddress = this.$CObj(this._getAddress)
        },
        editShippingAddress() {
            this.$emit('openShipping') 
        },
        removeClient() {
            this._getAddress = this.$CObj(Object.assign(this._getAddress, { id: 0, number: '' ,name: '', address1: '',city: '', zipcode: '', tel1: ''}))
        },
        removeBillingAddress() {
            this._getBillAddress = this.$CObj(Object.assign(this._getBillAddress, { id: 0, number: '' ,name: '', address1: '',city: '', zipcode: '', tel1: ''}))
        }
    },

 //------------------------------------------------------------------------------------------------
    computed: {
        isTxtSearch() {
            return (this.txtRecherche.length > 0)
        },
        /**
         * Retourne le payload sauvegardé dans le local
         */
         payload : () => store.getters.getSuppliersOnClient,
        /**
         * Retourne la liste des contacts du payload
         */
         termList() {return this.payload?.data.termList},

        _getAddress: {
            get: function() {return this.clientAddress},
            set: function(modifiedValue){this.$emit('update:clientAddress', modifiedValue)}
        },
        _getBillAddress: {
            get: function() {return this.billingAddress},
            set: function(modifiedValue){this.$emit('update:billingAddress', modifiedValue)}
        },
        
    },
//------------------------------------------------------------------------------------------------
    mounted() {

    },
//------------------------------------------------------------------------------------------------
    watch: {
        
    }
}
</script>

<style lang="scss" scoped>

.bg-white{
    background-color: white 
}



.text-sm{
    font-size: 0.875rem; /* 14px */
    line-height: 1.25rem; /* 20px */
}

.text-lg {
    line-height: 1.75rem
}


.items-center {
    align-items: center;
}		

.rounded-md	{
    border-radius: 0.375rem; /* 6px */
}


</style>